import { render, staticRenderFns } from "./PreWarningList.vue?vue&type=template&id=5442392e&scoped=true&"
import script from "./PreWarningList.vue?vue&type=script&lang=js&"
export * from "./PreWarningList.vue?vue&type=script&lang=js&"
import style0 from "./PreWarningList.vue?vue&type=style&index=0&id=5442392e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5442392e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5442392e')) {
      api.createRecord('5442392e', component.options)
    } else {
      api.reload('5442392e', component.options)
    }
    module.hot.accept("./PreWarningList.vue?vue&type=template&id=5442392e&scoped=true&", function () {
      api.rerender('5442392e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/PreWarning/components/PreWarningList.vue"
export default component.exports